import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { Column } from "primereact/column";
import { Fetch } from "../../../shared/Fetch";
import { ITrainingRatingDetails } from "./AllRating";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";

interface IProps {
    singleData: ITrainingRatingDetails,
    hideDialog: () => void,
    open: boolean,
    toast: any,
}

interface IRatingQuestionAnswer {
    question?: string,
    // answer?: boolean,
    rating?: number,
    feedback?: string | null,
    added_On?: Date,
}

export const RatingAnswers = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IRatingQuestionAnswer>, loading: boolean });
    const dt = useRef<any>(null);
    const onHide = () => {
        props.hideDialog();
    }
    const header = () => {
        return <p>Rating Answers</p>;
    }

    const add_Date = (rowData: IRatingQuestionAnswer) => {
        let date;
        if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("CarnivalTraining/getRatingQuestionsAns", "GET", null, `ratingID=${props.singleData.rating_ID}`, props.toast);
        if (response) {
            const data: IRatingQuestionAnswer[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const ratingStars = (rowData: IRatingQuestionAnswer) => {
        let stars: string[] = ["★", "★", "★", "★", "★"];
        return <p>{stars.map((el: string, index: number) => <span style={{ color: index <= ((rowData.rating || 0) - 1) ? "#FFD700" : "#ccc" }}>{el}</span>)}</p>
    }

    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '70vw' }} header="Rating Answers" modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                lazy dataKey="schedule_ID"
                emptyMessage="No Record found."
                value={tableData.tableData} loading={tableData.loading}
            // header={header}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="question" header="Question" />
                <Column field="question" header="Rating" body={(rowData: IRatingQuestionAnswer) => ratingStars(rowData)} />
                <Column field="feedback" header="Feedback" />
                <Column field="added_On" header="Asnwerd On" body={add_Date} />
            </DataTable>
        </Dialog>
    );
}